@if (originalLocationsLoaded) {
  <form [formGroup]="locationLockAccessForm" (ngSubmit)="formSubmitSubject.next()">
    <div class="form-group">
      <p>{{'LOCK_ACCESS_RIGHT_INFO' |translate}}</p>
    </div>
    <div class="form-group">
      <label><strong>{{'LOCATIONS' |translate}}</strong></label>
      <mat-selection-list #locationLockAccess formControlName="selectedLocationAccess" dense="true">
        @for (location of allLocations; track location) {
          <mat-list-option [value]="location.id">
            {{location.name}}
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
    <div class="form-group">
      @if (saveSuccess) {
        <div class="alert alert-success mt-2"><span class="fa-light fa-check"></span>
      {{'UPDATE_SUCCESS' |translate}}</div>
    }
  </div>
  @if (Areas.DevicesLocks | can: 'ReadWrite') {
    <div class="form-group">
      <button type="submit" class="btn btn-outline-primary gray-bg mr-1"><span class="fa-light fa-floppy-disk"></span>
    {{'SAVE' |translate}}</button>
  </div>
  }
</form>
}
